module.exports = __webpack_public_path__ + "static/media/b08.d49aae37.png";